import { ENDPOINTS } from "@/api/endpoints";
import { apiClient } from "@/lib/client";
import { TenantResponse } from "@/types/multiple-tenants.type";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { HTTPError } from "ky";

// const mockTenants: TenantResponse = [
//   {
//     id: 1,
//     name: "Thomas Scott",
//     subdomain: "thomasscott.in",
//   },
//   {
//     id: 2,
//     name: "CosX",
//     subdomain: "cosx.in",
//   },
//   {
//     id: 3,
//     name: "Manyavar",
//     subdomain: "manyavar.in",
//   },
//   {
//     id: 4,
//     name: "Tslitech",
//     subdomain: "tslitechq.in",
//   },
// ];
const useGetTenantsQuery = (
  options?: Omit<
    UseQueryOptions<TenantResponse, HTTPError, TenantResponse, ["tenants"]>,
    "queryKey" | "queryFn"
  >
) => {
  return useQuery({
    queryKey: ["tenants"],
    queryFn: async () => {
      const response = await apiClient.get(ENDPOINTS.GET_TENANTS);
      return response.json<TenantResponse>();
      // return mockTenants;
    },
    ...options,
  });
};

export default useGetTenantsQuery;
